import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col, FormGroup, FormLabel, FormControl, Image, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { login } from '../actions/userActions';
import SearchProduct from './SearchProduct';
import CreateRegistryForm from './RegistarEvent';
import FormContainer from '../components/FormContainer';
import ManageProduct from './ManageProduct';
import { LinkContainer } from 'react-router-bootstrap';
import axios from 'axios';

const HomeScreen = ({location,history }) => {
  const [email, setEmail] = useState('');
  const [giftregCustomer, setGiftregCustomer] = useState('');
  const [password, setPassword] = useState('');
  const dispatch=useDispatch();
  const userLogin=useSelector(state=>state.userLogin);  
  const {userInfo} = userLogin;  
  const redirect=location.search?location.search.split('=')[1]:'/';  
  const [activeTab, setActiveTab] = useState(0);  
  const [isAppInstall, setIsAppInstall] = useState(0);  
  const [pageSettingData, setPageSettingData] = useState({});  
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const submitHandler=(e)=>{
    e.preventDefault();
    dispatch(login(email,password));
  }
  
  useEffect(() => {    

    // CHECK APP IS INSTALLED OR NOT
    axios.get(`https://wiser-ai.expertvillagemedia.com/api/isappinstall/${window.Shopline.handle}`)
    .then((reschk) => {     
      //console.log("****************reschkreschkreschkreschkreschk***************************");
      setIsAppInstall(reschk.data.data);
      //setPageSettingData(res.data.data);
      //console.log("*******************************************");
    });
    

    //if (window.Shopline.customer === "" || window.Shopline.customer === undefined) {
    //   window.location.href = `http://${window.Shopline.handle}.myshopline.com/user/signIn`;
    // }
    // Register Customer CODE
    if (window.Shopline.customer !== undefined) {
      const Customer = fetch('https://wiser-ai.expertvillagemedia.com/api/register', {
        method: "POST",
        headers: 
        {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Allow": "OPTIONS, GET, HEAD, POST"
        },      
        body: JSON.stringify({
          handle: window.Shopline.handle !== '' ? window.Shopline.handle : 'NA',
          store_id: window.Shopline.storeId !=='' ? window.Shopline.storeId : 'NA',
          name: window.Shopline.customer.name !=='' ? window.Shopline.customer.name : 'NA',
          email: window.Shopline.customer.email !=='' ? window.Shopline.customer.email : 'NA',
          customer_id: window.Shopline.customer.id !=='' ? window.Shopline.customer.id : '0',
          password: '12345678'
        }),
      })
      .then((response) => response.text());
    }
    //
    /*
    const customerLoginResponse = fetch('https://wiser-ai.expertvillagemedia.com/api/login', {
      method: "POST",
      mode: 'cors',
      headers: 
      {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Allow": "OPTIONS, GET, HEAD, POST"
      },      
      body: JSON.stringify({        
        email: 'test@gmail.com',//Shopline.customer.email !== '' ? Shopline.customer.email : 'NA',    
        password: '123456789'
      }),
    })
    .then((response) => response.json())
    .then((responseJson) => {console.log(responseJson);})
    .catch((error) => {
        console.error(error);
    });   
    */    
    
    /*
    const settingData = fetch(`https://wiser-ai.expertvillagemedia.com/api/frontpagedesign/${window.Shopline.handle}`, {
      method: "GET",
      headers: 
      {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Allow": "OPTIONS, GET, HEAD, POST"
      }
    })
    .then((response) => response.json())
    .then((responseJson) => {        
        console.log("-----------------------responseJson.data-----------------------------------");        
        setPageSettingData(responseJson.data);
        console.log("-----------------------END responseJson.data-----------------------------------");        
    })
    .catch((error) => {
        console.error(error);
    });*/
    axios.get(`https://wiser-ai.expertvillagemedia.com/api/frontpagedesign/${window.Shopline.handle}`)
    .then((res) => {     
      setPageSettingData(res.data.data);
    });
  }, []);

  return (
      <div>
        {isAppInstall === false  &&
          <div className='create-registry-wr'>
            <h1>App is not installed </h1>
            <a href="/" >Back to Home</a>        
          </div>
        }
        {isAppInstall === true  &&  
          <>
            <div className="tab-buttons evm-button">
              <button className="evm-gift-btn search" 
              style={{"background-color": `${pageSettingData.find_btn_color}`}} 
              onClick={() => handleTabClick(0)}>
                {pageSettingData.find_btn_txt !== '' ? pageSettingData.find_btn_txt : 'Find'}
              </button>
              
              <button className="evm-gift-btn create" 
              style={{"background-color": `${pageSettingData.create_btn_color}`}} 
              onClick={() => handleTabClick(1)}>
                {pageSettingData.create_btn_txt !== '' ? pageSettingData.create_btn_txt : 'Create'}
              </button>
              
              <button className="evm-gift-btn manage" 
              style={{"background-color": `${pageSettingData.manage_btn_color}`}} 
              onClick={() => handleTabClick(2)}>
                {pageSettingData.manage_btn_txt !== '' ? pageSettingData.manage_btn_txt : 'Manage'}
              </button>
            </div>
            <div className="tab-content">
              {activeTab === 0  &&
              <div>
                <SearchProduct/>
              </div>}
              {activeTab === 1 && 
              <div>
                  <CreateRegistryForm/>
              </div>}
              {activeTab === 2 && 
              <div>
                  <ManageProduct/>              
              </div>
              }
            </div>
          </>
        }
      </div>    
  );
};
export default HomeScreen;